import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=2f95f704&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"
import style0 from "../../../styles/autocomplete.scss?vue&type=style&index=0&id=2f95f704&prod&scoped=true&lang=scss&external"
import style1 from "./Catalog.vue?vue&type=style&index=1&id=2f95f704&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95f704",
  null
  
)

export default component.exports